import api from './api';
import { AppResponse } from "../models/common/app-response";
import { DefaultIndicatorsDto } from '../models/medicalIndicators/defaultIndicatorsDto';

class DefaultHealthIndicatorsService {
    get() {
        return api.get<AppResponse<DefaultIndicatorsDto>>(`/api/v1/default-health-indicators`);
    }
}

export const defaultHealthIndicatorsService = new DefaultHealthIndicatorsService();
